<template>
  <div>
    <div class="headline d-flex flex-row align-items-center justify-content-between w-100 border-bottom pb-3">
      <h2 class="card-title font-weight-bolder">{{ $t('administrator.details.profile.title') }}</h2>
      <div v-if="isCreateAdministratorPage && !administratorData">
        <router-link :to="{ name: 'administrator' }">
          <button type="button" class="btn btn-secondary mr-1">{{ $t('administrator.details.btn.cancel') }}</button>
        </router-link>
<!--        <button @click="resetAdministratorData" class="btn btn-danger mr-1">{{ $t('administrator.details.btn.reset') }}</button>-->
        <button @click="saveAdministratorData" class="btn btn-success">{{ $t('administrator.details.btn.save') }}</button>
      </div>
    </div>
    <AdministratorDataForm ref="administrator-data-form"></AdministratorDataForm>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import AdministratorDataForm from "./AdministratorDataForm";

  export default {
    components: {
      AdministratorDataForm
    },
    computed: mapState({
      isCreateAdministratorPage: state => state.administrator.isCreateAdministratorPage,
      administratorData: state => state.administrator.administratorDetails
    }),
    methods: {
      saveAdministratorData() {
        this.$refs['administrator-data-form'].saveAdministratorData();
      },
      resetAdministratorData() {
        this.$store.commit('administrator/resetAdministratorDataForm');
        this.$store.commit('administrator/resetAdministratorPasswordForm');
      }
    }
  }
</script>
